<template>
    <div class="bizcomp-monthly-statement">
        <div class="monthly-statement-query">
            <div class="bar-contain">
                <div class="bar"></div>
                <div class="bar-text">对账单查询</div>
            </div>
            <div class="query-time-contain">
                <div class="query-time-content" v-on:click="selectIndexFn(0)">
                    <div class="query-time-text1">
                        <img src="@/assets/img/time-self.svg" alt="" />
                        <div class="query-time-text1-text">自定义时间段</div>
                    </div>
                    <div class="query-time-text2">请设置查询时间段</div>
                    <div :class="selectIndex == 0 ? 'select-bottom' : ''">
                        <img src="@/assets/img/hook.svg" alt="" />
                    </div>
                </div>
                <div class="query-time-content margin-20" v-on:click="selectIndexFn(1)">
                    <div class="query-time-text1">
                        <img src="@/assets/img/time-quarter.svg" alt="" />
                        <div class="query-time-text1-text">按季度</div>
                    </div>
                    <div class="query-time-text2">请选择查询季度</div>
                    <div :class="selectIndex == 1 ? 'select-bottom' : ''">
                        <img src="@/assets/img/hook.svg" alt="" />
                    </div>
                </div>
                <div class="query-time-content" v-on:click="selectIndexFn(2)">
                    <div class="query-time-text1">
                        <img src="@/assets/img/time-month.svg" alt="" />
                        <div class="query-time-text1-text">按月份</div>
                    </div>
                    <div class="query-time-text2">请选择查询月份</div>
                    <div :class="selectIndex == 2 ? 'select-bottom' : ''">
                        <img src="@/assets/img/hook.svg" alt="" />
                    </div>
                </div>
            </div>
            <div>
                <div v-if="selectIndex == 0" class="time-select-contain">
                    <date-picker sep-text="-" :date="dateSet" v-on:date-get="dateInterval" />
                    <button class="query-btn" v-on:click="searchDateTrade">查询</button>
                </div>
                <div v-else-if="selectIndex == 1" class="time-select-contain">
                    <el-date-picker
                        v-model="yearValue1"
                        type="year"
                        placeholder="请选择年份"
                        :picker-options="pickerOptions"
                        v-on:change="yearTimeChange"
                    ></el-date-picker>
                    <div class="null-bar"></div>
                    <el-select v-model="quarterValue" placeholder="请选择季度">
                        <el-option
                            v-for="item in quarterOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                    <button class="query-btn" v-on:click="searchDateTrade">查询</button>
                </div>
                <div v-else class="time-select-contain">
                    <el-date-picker
                        v-model="yearValue2"
                        type="year"
                        placeholder="请选择年份"
                        :picker-options="pickerOptions"
                        v-on:change="yearTimeChange"
                    ></el-date-picker>
                    <div class="null-bar"></div>

                    <el-select v-model="monthValue" placeholder="请选择月份">
                        <el-option
                            v-for="item in monthOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                    <button class="query-btn" v-on:click="searchDateTrade">查询</button>
                </div>
            </div>
        </div>
        <div class="monthly-statement-edit">
            <div class="bar-contain">
                <div class="bar"></div>
                <div class="bar-text">对账单定制</div>
            </div>
            <div class="statement-edit-contain">
                <div class="statement-edit-content">
                    <div class="statement-edit-text1">
                        <div class="statement-edit-text1-text">季度短信对账单</div>
                        <el-checkbox-group v-model="editIndex1">
                            <el-checkbox name="statementEdit" v-on:change="subCheck"></el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div class="statement-edit-text2">
                        <img src="@/assets/img/sms.svg" alt="" />
                    </div>
                </div>
                <div class="statement-edit-content margin-20">
                    <div class="statement-edit-text1">
                        <div class="statement-edit-text1-text">季度邮件对账单</div>
                        <el-checkbox-group v-model="editIndex2">
                            <el-checkbox name="statementEdit" v-on:change="subCheck"></el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div class="statement-edit-text2">
                        <img src="@/assets/img/email.svg" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import format from "date-fns/format";
import datePicker from "@/components/form/datePicker";
import userApi from "@/api/user";

export default {
    name: "TradeHistory",
    components: {
        datePicker
    },
    mixins: [mixin],

    data() {
        return {
            endDate: "",
            beginDate: "",
            nowDate: "", // 当前时间
            dateSet: {
                type: "2",
                min: "19900101",
                size: "mini",
                text: "开始时间",
                text2: "结束时间"
            },
            selectIndex: 0,
            editIndex1: false,
            editIndex2: false,
            yearValue1: "",
            yearValue2: "",
            quarterOptions: [],
            quarterValue: "",
            monthOptions: [],
            monthValue: "",
            queryStartTime: "",
            queryEndTime: "",
            pickerOptions: {
                disabledDate(time) {
                    return time.getFullYear() > new Date().getFullYear();
                }
            },
            timer: null,
            quarterFormatValue: [
                { start: "0101", end: "0331" },
                { start: "0401", end: "0630" },
                { start: "0701", end: "0930" },
                { start: "1001", end: "1231" }
            ]
        };
    },
    mounted() {
        this.nowDate = format(new Date(), "YYYYMMDD");
        this.dateSet.max = this.$util.fmtDate(this.nowDate);
        this.yearValue1 = new Date();
        this.yearValue2 = new Date();
        this.yearTimeChange(new Date());
        this.qryCustomizedServer();
    },
    methods: {
        yearTimeChange(value) {
            if (this.selectIndex != 2) {
                this.quarterOptions = [];
            } else if (this.selectIndex != 1) {
                this.monthOptions = [];
            }
            if (value) {
                const allMonth = [
                    {
                        value: "01",
                        label: "一月"
                    },
                    {
                        value: "02",
                        label: "二月"
                    },
                    {
                        value: "03",
                        label: "三月"
                    },
                    {
                        value: "04",
                        label: "四月"
                    },
                    {
                        value: "05",
                        label: "五月"
                    },
                    {
                        value: "06",
                        label: "六月"
                    },
                    {
                        value: "07",
                        label: "七月"
                    },
                    {
                        value: "08",
                        label: "八月"
                    },
                    {
                        value: "09",
                        label: "九月"
                    },
                    {
                        value: "10",
                        label: "十月"
                    },
                    {
                        value: "11",
                        label: "十一月"
                    },
                    {
                        value: "12",
                        label: "十二月"
                    }
                ];
                const allQuarter = [
                    {
                        value: "1",
                        label: "第一季度"
                    },
                    {
                        value: "2",
                        label: "第二季度"
                    },
                    {
                        value: "3",
                        label: "第三季度"
                    },
                    {
                        value: "4",
                        label: "第四季度"
                    }
                ];
                if (value.getFullYear() == new Date().getFullYear()) {
                    if (this.selectIndex != 2) {
                        if (
                            Number(new Date().getMonth() + 1) >= 1 &&
                            Number(new Date().getMonth() + 1) < 4
                        ) {
                            this.quarterOptions.push(allQuarter[0]);
                        } else if (
                            Number(new Date().getMonth() + 1) >= 4 &&
                            Number(new Date().getMonth() + 1) < 7
                        ) {
                            this.quarterOptions.push(allQuarter[0]);
                            this.quarterOptions.push(allQuarter[1]);
                        } else if (
                            Number(new Date().getMonth() + 1) >= 7 &&
                            Number(new Date().getMonth() + 1) < 10
                        ) {
                            this.quarterOptions.push(allQuarter[0]);
                            this.quarterOptions.push(allQuarter[1]);
                            this.quarterOptions.push(allQuarter[2]);
                        } else {
                            this.quarterOptions.push(allQuarter[0]);
                            this.quarterOptions.push(allQuarter[1]);
                            this.quarterOptions.push(allQuarter[2]);
                            this.quarterOptions.push(allQuarter[4]);
                        }
                    }
                    if (this.selectIndex != 1) {
                        for (let i = 0; i < Number(new Date().getMonth() + 1); i++) {
                            this.monthOptions.push(allMonth[i]);
                        }
                    }
                } else {
                    if (this.selectIndex != 2) {
                        allQuarter.forEach((item) => {
                            this.quarterOptions.push(item);
                        });
                    } else if (this.selectIndex != 1) {
                        allMonth.forEach((item) => {
                            this.monthOptions.push(item);
                        });
                    }
                }
            }
        },
        selectIndexFn(index) {
            this.selectIndex = index;
        },
        // 获取用户选中时间区间
        dateInterval(val) {
            // convert "YYYY-MM-DD" to "YYYYMMDD"
            this.beginDate = this.$util.isEmpty(val.beginDate)
                ? ""
                : val.beginDate.replace(/-/g, "");
            this.endDate = this.$util.isEmpty(val.endDate) ? "" : val.endDate.replace(/-/g, "");
        },
        // 搜索时间区间交易记录
        searchDateTrade() {
            if (this.formatSelectData()) {
                this.$router.push({
                    name: "statement",
                    query: {
                        begindate: this.queryStartTime,
                        enddate: this.queryEndTime
                    }
                });
            }
        },
        formatSelectData() {
            if (this.selectIndex == "0") {
                if (this.$util.isEmpty(this.beginDate) || this.$util.isEmpty(this.endDate)) {
                    this.$alert("请输入完整的日期范围", "日期提示");
                    return false;
                }
                this.queryStartTime = this.beginDate;
                this.queryEndTime = this.endDate;
            } else if (this.selectIndex == "1") {
                if (this.$util.isEmpty(this.yearValue1) || this.$util.isEmpty(this.quarterValue)) {
                    this.$alert("请输入完整的日期范围", "日期提示");
                    return false;
                }
                this.queryStartTime =
                    this.yearValue1.getFullYear() +
                    this.quarterFormatValue[Number(this.quarterValue) - 1].start;
                if (
                    this.yearValue1.getFullYear() == this.nowDate.slice(0, 4) &&
                    Number(this.nowDate.slice(4, 6)) <=
                        Number(
                            this.quarterFormatValue[Number(this.quarterValue) - 1].end.slice(0, 2)
                        )
                ) {
                    this.queryEndTime = this.nowDate;
                } else {
                    this.queryEndTime =
                        this.yearValue1.getFullYear() +
                        this.quarterFormatValue[Number(this.quarterValue) - 1].end;
                }
            } else {
                if (this.$util.isEmpty(this.yearValue2) || this.$util.isEmpty(this.monthValue)) {
                    this.$alert("请输入完整的日期范围", "日期提示");
                    return false;
                }
                if (
                    this.monthValue == "01" ||
                    this.monthValue == "03" ||
                    this.monthValue == "05" ||
                    this.monthValue == "07" ||
                    this.monthValue == "08" ||
                    this.monthValue == "10" ||
                    this.monthValue == "12"
                ) {
                    this.queryStartTime = this.yearValue2.getFullYear() + this.monthValue + "01";
                    this.queryEndTime = this.yearValue2.getFullYear() + this.monthValue + "31";
                } else if (
                    this.monthValue == "04" ||
                    this.monthValue == "06" ||
                    this.monthValue == "09" ||
                    this.monthValue == "11"
                ) {
                    this.queryStartTime = this.yearValue2.getFullYear() + this.monthValue + "01";
                    this.queryEndTime = this.yearValue2.getFullYear() + this.monthValue + "30";
                } else {
                    const februaryNum = this.getDaysInFebruary(this.yearValue2.getFullYear());
                    this.queryStartTime = this.yearValue2.getFullYear() + this.monthValue + "01";
                    this.queryEndTime =
                        this.yearValue2.getFullYear() + this.monthValue + februaryNum;
                }
                if (
                    this.yearValue2.getFullYear() == this.nowDate.slice(0, 4) &&
                    this.nowDate.slice(4, 6) == this.monthValue
                ) {
                    this.queryEndTime = this.nowDate;
                }
            }
            return true;
        },
        getDaysInFebruary(year) {
            return (Number(year) % 4 === 0 && Number(year) % 100 !== 0) || Number(year) % 400 === 0
                ? "29"
                : "28";
        },
        async qryCustomizedServer() {
            const checkeInfos = await userApi.qryCustomizedServer({
                qrytype: "a"
            });
            if (checkeInfos.data) {
                checkeInfos.data.forEach((item) => {
                    if (item.columno == "50") {
                        this.editIndex1 = item.status == "1";
                    } else if (item.columno == "10000") {
                        this.editIndex2 = item.status == "1";
                    }
                });
            } else {
                this.editIndex1 = false;
                this.editIndex2 = false;
            }
        },
        subCheck() {
            if (this.timer) clearTimeout(this.timer);
            this.timer = setTimeout(async () => {
                const columnList = [
                    {
                        columno: "50",
                        status: this.editIndex1 ? "1" : "0"
                    },
                    {
                        columno: "10000",
                        status: this.editIndex2 ? "1" : "0"
                    }
                ];
                const res = await userApi.modifyCustomizedServer({
                    columnList: columnList
                });
                if (res.code == "0") {
                    this.$message({
                        type: "success",
                        message: "修改服务定制信息成功！"
                    });
                }
                this.qryCustomizedServer();
            }, 1000);
        }
    }
};
</script>

<style lang="scss" scoped>
.bizcomp-monthly-statement {
    .bar-contain {
        display: flex;
        align-items: center;
        margin: 36px 0 16px;
        .bar {
            width: 3.71px;
            height: 16.73px;
            background: #e60012;
        }
        .bar-text {
            margin-left: 6.29px;
            font-family: Source Han Sans CN;
            font-size: 18px;
            font-weight: 500;
            color: #333333;
        }
    }
    .monthly-statement-query {
        padding-bottom: 22px;
        .query-time-contain {
            display: flex;
            .query-time-content {
                width: 234px;
                height: 114px;
                border-radius: 6px;
                background: #ffffff;
                box-sizing: border-box;
                border: 1px solid #d9d9d9;
                position: relative;
                cursor: pointer;
                .query-time-text1 {
                    padding: 16px 0 10px 10px;
                    display: flex;
                    align-items: center;
                    .query-time-text1-text {
                        font-size: 18px;
                        font-weight: 500;
                        color: #333333;
                        margin-left: 5.98px;
                    }
                }
                .query-time-text2 {
                    margin-left: 36px;
                    font-size: 14px;
                    font-weight: normal;
                    color: #999999;
                }
                .select-bottom {
                    width: 100%;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                    border-radius: 0px 0px 5px 5px;
                    background: #e60012;
                    position: absolute;
                    bottom: 0;
                }
            }
        }
        .time-select-contain {
            margin-top: 20px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            .null-bar {
                padding: 0 12px;
            }
            .query-btn {
                width: 90px;
                height: 40px;
                line-height: 40px;
                border-radius: 2px;
                background: #e60012;
                font-size: 16px;
                font-weight: 500;
                text-align: center;
                color: #ffffff;
                cursor: pointer;
                border: none;
                margin-left: 10px;
            }
        }
    }
    .monthly-statement-edit {
        padding-bottom: 66px;
        .statement-edit-contain {
            display: flex;
            .statement-edit-content {
                width: 234px;
                height: 125px;
                border-radius: 6px;
                padding: 12px 16px;
                box-sizing: border-box;
                background: linear-gradient(180deg, #f9f9f9 0%, #eeeeee 100%);
                .statement-edit-text1 {
                    display: flex;
                    justify-content: space-between;
                    .statement-edit-text1-text {
                        height: 20px;
                        font-size: 18px;
                        font-weight: 500;
                        color: #333333;
                    }
                }
                .statement-edit-text2 {
                    margin-top: 18px;
                }
            }
        }
    }

    :deep(.comp-date-picker) {
        width: 386px;
    }
    :deep(.el-input) {
        width: 180px;
        height: 40px;
        font-size: 16px;
        .el-input__inner {
            width: 180px;
            height: 40px;
            background: #ffffff;
            box-sizing: border-box;
            border-radius: 2px;
            border: 1px solid #d9d9d9;
            padding: 0 38px;
        }
        .el-input__prefix {
            padding-left: 4px;
        }
        .el-input__icon {
            line-height: 40px;
        }
        .el-icon-date:before {
            font-size: 22px;
        }
    }
    :deep(.el-select) {
        .el-input__inner {
            padding-left: 13px !important;
        }
    }
    .margin-20 {
        margin: 0 20px;
    }
}
:deep(.el-date-picker__header) {
    display: none !important;
}
:deep(.el-date-picker__header--bordered) {
    display: none !important;
}
</style>
